import { useTranslation } from 'react-i18next';

/** Rótulos do `Pagination` (Aluma) no idioma ativo — o default é fixo em pt-BR. Espalhe no componente. */
export function usePaginationLabels() {
  const { t } = useTranslation('common');
  return {
    'aria-label': t('pagination.navigation'),
    labels: {
      previous: t('pagination.previous'),
      next: t('pagination.next'),
      page: (page: number) => t('pagination.page', { page }),
    },
  };
}
